import { Component, Input } from '@angular/core';
import { NotificationsService } from 'angular2-notifications';
import 'rxjs/add/operator/finally';

import { Subscription, SubscriptionOffer, Option, OptionOffer } from '../../../entities/index';
import { SubscriptionService } from '../../../services/subscription.service';
import { SubscriptionOfferService } from '../../../services/subscription-offer.service';


@Component({
  selector: 'app-option-information',
  templateUrl: './option-information.html'
})
export class OptionInformationComponent {
  _subscription: Subscription;

  loading = false;
  options: Array<Option> = [];
  offers: SubscriptionOffer[] = [];
  selectedOpts: any = {};

  constructor(protected subscriptionService: SubscriptionService,
              protected subscriptionOfferService: SubscriptionOfferService,
              protected notification: NotificationsService) {
  }

  mapOptionOfferToOption = (offer: OptionOffer): Option => {    
    const option_in_db = this._subscription.options.find((option) => option.code == offer.code)
    if (option_in_db === undefined) {
      const option: Option = {
        id: null,
        activated: false,
        activation_date: null,
        amount: offer.price_offer.fr.amount,
        code: offer.code,
        created_at: null,
        updated_at: null,
        is_running: null,
        next_charge_at: null,
        subscription_id: this.subscription.id,
      }
      return option;
    }
    return option_in_db;
  }

  initOptions = () => {
    this.subscriptionOfferService.getAll().then((offers: SubscriptionOffer[]) => {
      const subscriptionOffer = offers.find((subOffer) => subOffer.id == this._subscription.offer_id)
      subscriptionOffer.subscription_option_offers.forEach((optOffer) => {
        this.options.push(
          this.mapOptionOfferToOption(optOffer)
        )
      })
    })
  }

  @Input()
  set subscription(subscription: Subscription) {
    this._subscription = subscription;

    if (subscription && !!subscription.id) {
      this.initOptions()
    } else {
      this._subscription = undefined;
      this.options = [];
      this.selectedOpts = {};
    }
  }

  get subscription() {
    return this._subscription;
  }

  toggleOption = (optionCode: string) => {
    const matchedOption = this.options.find((option) => option.code === optionCode);
    if (matchedOption !== undefined) {
      matchedOption.activated = !matchedOption.activated;
    }

    const activatedOptions = this.options.filter((opt) => opt.activated);
    const activatedOptionCodes = activatedOptions.map((opt) => opt.code);

    this.subscriptionService
      .put(this._subscription.id, activatedOptionCodes)
      .finally(() => this.loading = false)
      .subscribe((subscription: Subscription) => {
        this._subscription = subscription;
        // Replace each option in this.options by those from subscription.options
        subscription.options.forEach((opt) => {
          const index = this.options.findIndex((o) => o.code === opt.code)
          this.options[index] = opt;
        });
      })
  }
}



// WEBPACK FOOTER //
// /builds/weenect1/backofficev3/src/app/components/blocks/option-information/option-information.component.ts